// Función para validar un documento XML contra el esquema XSD
export const validateECMR = async (xmlString: string): Promise<{ valid: boolean, errors?: string[] }> => {
  try {
    // Validación básica usando DOMParser nativo del navegador
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
    
    // Verificar errores de parsing
    const parseError = xmlDoc.querySelector('parsererror');
    if (parseError) {
      return {
        valid: false,
        errors: [`Error de sintaxis XML: ${parseError.textContent}`]
      };
    }
    
    const errors: string[] = [];
    
    // Verificar si es un documento eCMR válido
    const rootElement = xmlDoc.documentElement;
    if (!rootElement || (rootElement.tagName !== 'rsm:eCMR' && rootElement.tagName !== 'eCMR')) {
      errors.push('El documento XML no tiene la estructura raíz de un eCMR');
    }
    
    // Verificar componentes obligatorios básicos
    if (!xmlDoc.querySelector('ExchangedDocument')) {
      errors.push('Falta el componente ExchangedDocument');
    }
    
    if (!xmlDoc.querySelector('SpecifiedSupplyChainConsignment')) {
      errors.push('Falta el componente SpecifiedSupplyChainConsignment');
    }
    
    // Verificar datos obligatorios
    if (xmlDoc.querySelector('SpecifiedSupplyChainConsignment')) {
      if (!xmlDoc.querySelector('ConsignorTradeParty')) {
        errors.push('Falta información del remitente (ConsignorTradeParty)');
      }
      
      if (!xmlDoc.querySelector('ConsigneeTradeParty')) {
        errors.push('Falta información del destinatario (ConsigneeTradeParty)');
      }
      
      if (!xmlDoc.querySelector('CarrierTradeParty')) {
        errors.push('Falta información del transportista (CarrierTradeParty)');
      }
    }
    
    return {
      valid: errors.length === 0,
      errors: errors.length > 0 ? errors : undefined
    };
  } catch (error) {
    return {
      valid: false,
      errors: [`Error al analizar el XML: ${(error as Error).message}`]
    };
  }
};

// Función para obtener códigos estándar desde los esquemas
export const getStandardCodes = (codeType: string): { code: string, description: string }[] => {
  // Aquí se implementaría la extracción de códigos desde los esquemas XSD
  
  // Por ahora, devolvemos algunos ejemplos para distintos tipos de códigos
  switch(codeType) {
    case 'CountryCode':
      return [
        { code: 'ES', description: 'España' },
        { code: 'FR', description: 'Francia' },
        { code: 'DE', description: 'Alemania' },
        { code: 'IT', description: 'Italia' },
        { code: 'PT', description: 'Portugal' },
        { code: 'UK', description: 'Reino Unido' }
      ];
      
    case 'TransportModeCode':
      return [
        { code: '1', description: 'Marítimo' },
        { code: '2', description: 'Ferroviario' },
        { code: '3', description: 'Carretera' },
        { code: '4', description: 'Aéreo' },
        { code: '5', description: 'Postal' },
        { code: '6', description: 'Multimodal' },
        { code: '7', description: 'Instalación fija de transporte' },
        { code: '8', description: 'Navegación interior' }
      ];
      
    case 'PackageTypeCode':
      return [
        { code: 'PK', description: 'Paquete' },
        { code: 'CT', description: 'Cartón' },
        { code: 'CS', description: 'Caja' },
        { code: 'PL', description: 'Palé' },
        { code: 'DR', description: 'Tambor' },
        { code: 'BX', description: 'Caja' }
      ];
      
    case 'DeliveryTermsCode':
      return [
        { code: 'EXW', description: 'Ex Works' },
        { code: 'FCA', description: 'Free Carrier' },
        { code: 'CPT', description: 'Carriage Paid To' },
        { code: 'CIP', description: 'Carriage and Insurance Paid To' },
        { code: 'DAP', description: 'Delivered At Place' },
        { code: 'DPU', description: 'Delivered at Place Unloaded' },
        { code: 'DDP', description: 'Delivered Duty Paid' }
      ];
      
    default:
      return [];
  }
}; 